var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4646 14.1844C20.3071 11.1215 11.7999 10.8398 6.87647 12.3341C6.08567 12.5741 5.24959 12.1278 5.00999 11.3372C4.7704 10.546 5.21634 9.71047 6.00752 9.47012C11.6593 7.75458 21.0547 8.08588 26.9921 11.6104C27.7032 12.0326 27.9365 12.9511 27.515 13.661C27.0932 14.3722 26.174 14.6066 25.4646 14.1844ZM25.2957 18.7209C24.9338 19.308 24.1661 19.4922 23.5798 19.1317C19.2799 16.4887 12.7233 15.723 7.63632 17.2671C6.97658 17.4664 6.27998 17.0946 6.07955 16.436C5.88085 15.7765 6.25285 15.081 6.91143 14.8804C12.7225 13.1169 19.9467 13.9709 24.8853 17.0059C25.4716 17.367 25.6562 18.1351 25.2957 18.7209ZM23.3379 23.0777C23.0503 23.5492 22.4365 23.6969 21.9666 23.4095C18.2094 21.1132 13.4803 20.5946 7.91087 21.8667C7.37418 21.9898 6.83921 21.6535 6.71674 21.1168C6.59389 20.5803 6.92901 20.0453 7.46685 19.9229C13.5617 18.5296 18.7897 19.1292 23.007 21.7062C23.4772 21.9934 23.6252 22.6076 23.3379 23.0777ZM16 0C7.16363 0 0 7.16344 0 15.9998C0 24.8371 7.16363 32 16 32C24.8368 32 32 24.8371 32 15.9998C32 7.16344 24.8368 0 16 0V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.8f3d83c5f8cc3d0c8016d9beadb0d89e.svg";
export { ForwardRef as ReactComponent };